<template>
  <div class="card modal-card">
    <div v-if="showHeader" class="el-card__header card-header-dark modal-header">
      <div class="font-weight-bold">
        <slot name="modal-header"></slot>
      </div>
      <el-button class="modal-close" @click="$emit('close')">
        <i class="el-icon-close" />
      </el-button>
    </div>
    <div :class="{ 'no-side-padding': noSidePadding, 'overflow-hidden': overflowHidden }" class="card-body modal-body">
      <slot></slot>
    </div>
    <div v-if="showFooter" class="card-footer card-footer-dark d-flex justify-content-end">
      <slot name="modal-footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  components: {},
  props: {
    loading: Boolean,
    noSidePadding: Boolean,
    overflowHidden: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showFooter() {
      return !!this.$slots['modal-footer'];
    },
    showHeader() {
      return !!this.$slots['modal-header'];
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../styles/colors';
.modal-card {
  max-height: calc(100vh - #{2 * 3px});
}

.modal-body {
  max-height: 80vh;
  overflow-y: auto;
  padding: 1rem;
}

.no-side-padding {
  padding-left: 0;
  padding-right: 0;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: $--color-dark-gray;
  i {
    color: $--color-dark-gray;
  }
}
</style>
